export const POST_RESUME = 'POST_RESUME';
export const LIST_RESUME = 'LIST_RESUME';
export const POST_VALIDATE = 'POST_VALIDATE';
